<script>
    export let fill = '#000'
</script>

<style>
    svg#event-link-icons {
        position: absolute;
        top: 230px;
        left: 18px;
        width: 28.21px;
        height: 201.45px;
    }

    .cls-1,
    .cls-2 {
        stroke: #000;
        stroke-miterlimit: 10;
        stroke-width: 0.27px;
    }
</style>

<svg id="event-link-icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.21 201.45">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <path
                {fill}
                class="cls-1"
                d="M18.42,3.16,15.26,0,0,15.26l3.16,3.16a1.49,1.49,0,0,1,2.1,2.11l3.16,3.16L23.69,8.42,20.53,5.26a1.49,1.49,0,0,1-2.11-2.1ZM3.68,14.74l3.69-3.69L9,12.63,5.26,16.32Zm2.11,2.1,3.68-3.68.53.53L6.32,17.37Zm1,1.06,3.69-3.69,1.05,1L7.9,19Zm5.79-1.58L9,20l-.53-.52,3.69-3.69Zm2.63-1.58-.52.52L7.9,8.42l.52-.52Zm1-4.43-1-1-1,1L13,9.09l1-1-1-1,3.86-.65Z"
            />
            <path {fill} class="cls-1" d="M15.68,48.49a8,8,0,0,0-5.06-2.12v7.68h2.45a8.06,8.06,0,0,1,2.61-5.56" />
            <path {fill} class="cls-1" d="M2.14,54.05a8,8,0,0,1,2-5,7.29,7.29,0,0,1,2.38,5Z" />
            <path {fill} class="cls-1" d="M7.37,54.05H9.81V46.37a8.1,8.1,0,0,0-5.06,2.11,8.11,8.11,0,0,1,2.62,5.57" />
            <path {fill} class="cls-1" d="M4.75,60.43a8.06,8.06,0,0,0,5.06,2.12V54.86H7.37a8.08,8.08,0,0,1-2.62,5.57" />
            <path {fill} class="cls-1" d="M10.62,54.86v7.69a8,8,0,0,0,5.06-2.12,8.09,8.09,0,0,1-2.61-5.57Z" />
            <path {fill} class="cls-1" d="M4.18,59.85a8,8,0,0,1-2-5H6.56a7.29,7.29,0,0,1-2.38,5" />
            <path
                {fill}
                class="cls-1"
                d="M28.21,51.29a5.81,5.81,0,1,0-5.81,5.8,5.81,5.81,0,0,0,5.81-5.8m-7.49-1L20,54.34H18.83l1.11-6.49h1.19l1.48,4.47,1.5-4.47H25.3l1.07,6.49H25.19l-.68-4.05-1.37,4.05H22.07Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M18.78,56.82a8.93,8.93,0,1,1-2.24-8.6c.14-.25.28-.49.44-.72a9.73,9.73,0,1,0,2.53,9.73c-.25-.13-.5-.26-.73-.41"
            />
            <path
                {fill}
                class="cls-1"
                d="M16.82,49.69a5.63,5.63,0,0,0-.23,1.6,5.71,5.71,0,0,0,.7,2.76h1.07A8.06,8.06,0,0,0,16.82,49.69Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M15.84,51.29a6.59,6.59,0,0,1,.34-2.09,7.31,7.31,0,0,0-2.24,4.85h2.52A6.53,6.53,0,0,1,15.84,51.29Z"
            />
            <path {fill} class="cls-1" d="M17.83,54.86a5.11,5.11,0,0,0,.48.55,4.87,4.87,0,0,0,.06-.55Z" />
            <path
                {fill}
                class="cls-1"
                d="M16.91,54.86h-3a7.29,7.29,0,0,0,2.38,5,8.06,8.06,0,0,0,1.85-3.56A6.38,6.38,0,0,1,16.91,54.86Z"
            />
            <path
                {fill}
                class="cls-2"
                d="M15.56,89.49a.49.49,0,0,0-.47,0L6.93,94.2a.68.68,0,0,0-.12.12h-3a1.35,1.35,0,0,0-1.34,1.36v4.09a1.36,1.36,0,0,0,1.34,1.37H7l8.07,5.24a.5.5,0,0,0,.26.08.46.46,0,0,0,.22-.06.47.47,0,0,0,.25-.41V89.9A.47.47,0,0,0,15.56,89.49Z"
            />
            <line {fill} class="cls-2" x1="18.42" y1="97.94" x2="23.74" y2="97.94" />
            <line {fill} class="cls-2" x1="18.42" y1="100.87" x2="23.03" y2="103.53" />
            <line {fill} class="cls-2" x1="18.42" y1="95.02" x2="23.03" y2="92.35" />
            <path
                {fill}
                class="cls-1"
                d="M18.44,139.8v-.28a2.69,2.69,0,0,0-2.68-2.69H4.92a2.7,2.7,0,0,0-2.68,2.69v9a2.7,2.7,0,0,0,2.68,2.69H15.7a2.72,2.72,0,0,0,2.74-2.67Zm-4,4.42-6.36,3.67a.23.23,0,0,1-.14,0,.25.25,0,0,1-.14,0,.27.27,0,0,1-.14-.24v-7.34a.29.29,0,0,1,.14-.25.28.28,0,0,1,.28,0l6.36,3.67a.29.29,0,0,1,.14.25A.27.27,0,0,1,14.42,144.22Z"
            />
            <polygon {fill} class="cls-1" points="19.34 147.94 23.84 149.71 23.84 138.25 19.34 140.01 19.34 147.94" />
            <rect {fill} class="cls-1" x="24.74" y="138.25" width="0.9" height="11.46" />
            <path
                {fill}
                class="cls-1"
                d="M26.47,183.73v15.5c-4.87,0-9.13.24-11.86,1.9v-17.4H14v17.4c-2.73-1.66-7-1.9-11.86-1.9v-15.5H1v17.14H27.45V183.73Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M14,201.45a.34.34,0,0,1-.17,0c-2.53-1.53-6.5-1.85-11.69-1.85a.32.32,0,0,1-.32-.32V181.66a.32.32,0,0,1,.32-.32c4.27,0,9.07.15,12,1.94a.32.32,0,0,1,.16.27v17.58a.34.34,0,0,1-.17.28A.42.42,0,0,1,14,201.45ZM2.48,198.91c5,0,8.62.32,11.22,1.67V183.74C11.21,182.31,7.41,182,2.48,182Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M14.61,201.45a.35.35,0,0,1-.14,0,.33.33,0,0,1-.18-.29V183.55a.32.32,0,0,1,.11-.24,12.45,12.45,0,0,1,3.1-1.69,15.45,15.45,0,0,0,4.87-2.92.32.32,0,0,1,.35-.07.35.35,0,0,1,.19.3V196.5a.37.37,0,0,1-.1.24,16,16,0,0,1-5,3,12.07,12.07,0,0,0-3,1.59A.32.32,0,0,1,14.61,201.45Zm.32-17.74v16.78a14.69,14.69,0,0,1,2.57-1.29,15.49,15.49,0,0,0,4.77-2.84V179.64a17,17,0,0,1-4.51,2.57A12.13,12.13,0,0,0,14.93,183.71Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M11.83,194.39a.34.34,0,0,1-.17,0c-1.53-.93-3.95-1.12-7.11-1.12a.32.32,0,1,1,0-.63c3.36,0,5.78.2,7.44,1.2a.33.33,0,0,1,.11.44A.32.32,0,0,1,11.83,194.39Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M11.83,190a.34.34,0,0,1-.17-.05c-1.53-.92-3.95-1.11-7.11-1.11a.32.32,0,0,1-.32-.32v-3.68a.32.32,0,0,1,.32-.32c3.36,0,5.78.2,7.44,1.2a.33.33,0,0,1,.16.28v3.68a.31.31,0,0,1-.17.28A.26.26,0,0,1,11.83,190Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M11.83,196.28a.34.34,0,0,1-.17-.05c-1.53-.92-3.95-1.11-7.11-1.11a.32.32,0,0,1-.32-.32.32.32,0,0,1,.32-.32c3.36,0,5.78.2,7.44,1.21a.32.32,0,0,1,.11.44A.33.33,0,0,1,11.83,196.28Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M9.48,191.51H9.42a26.87,26.87,0,0,0-4.87-.33.32.32,0,0,1-.32-.32.32.32,0,0,1,.32-.32,27.42,27.42,0,0,1,5,.34.32.32,0,0,1-.06.63Z"
            />
            <path
                {fill}
                class="cls-1"
                d="M26.47,181.34c-1.27,0-2.58,0-3.88.08v.64c1.11-.05,2.3-.08,3.56-.08v16.93a34.44,34.44,0,0,0-9.22.89,9.19,9.19,0,0,0-2.32,1.33V183.55a9.51,9.51,0,0,1,2.23-1.29,10.2,10.2,0,0,0-2.4,1,.33.33,0,0,0-.15.27v17.58a.33.33,0,0,0,.16.28.42.42,0,0,0,.16,0,.33.33,0,0,0,.16,0c2.53-1.53,6.51-1.85,11.7-1.85a.32.32,0,0,0,.32-.32V181.66A.32.32,0,0,0,26.47,181.34Z"
            />
            <rect {fill} class="cls-1" x="14.02" y="201.04" width="0.59" height="0.4" />
        </g>
    </g>
</svg>
